import React from "react";
import { styled } from "styled-components";
import { rem } from "../../../utils";
import { Colors, mediaQueries } from "../../../styles";
import { Paragraph } from "../../Text";
import FooterPrivacyNote from "../FooterPrivacyNote";
const StyledFooter = styled.footer `
  padding: ${rem(40)} ${rem(20)};
  background: ${Colors.GRAY_LIGHT};
  color: ${Colors.GRAY_DARKEST};
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
`;
export const FooterHeader = styled.h3 `
  font-size: ${rem(20)};
  margin: ${rem(40)} 0 ${rem(20)};
`;
const FooterSections = styled.div `
  display: flex;
  flex-direction: column;

  margin-top: ${rem(-40)};
  ${mediaQueries.up("small") `
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-start;
    margin-left: ${rem(-20)};
    margin-right: ${rem(-20)};
    > div {
    margin-left: ${rem(20)};
    margin-right: ${rem(20)};
    }
  `}
`;
export const Footer = ({ children, locale }) => (React.createElement(StyledFooter, null,
    React.createElement(FooterSections, null, children),
    React.createElement(FooterPrivacyNote, { locale: locale }),
    React.createElement(Paragraph, null,
        "\u00A9 ",
        new Date().getFullYear(),
        "\u00A0Fjord Line AS.")));
export default Footer;
//# sourceMappingURL=index.js.map